module.exports = __webpack_public_path__ + "static/media/63.2cdb9436.jpg";